import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import Index from "./page/index";
import Game from "./page/game";
import Mobile from "./page/mobile";
import GiftShop from "./page/gift_shop";
import PaymentGame from "./page/payment_game";
import PaymentMobile from "./page/payment_mobile";
import PolicyPrivacy from "./page/policy_privacy";
import Login from "./page/login";
import Register from "./page/register";

import Notfound from "./page/notfound";

const AppRoutes = () => (
  <Routes>
    <Route path="/" element={<Index />} />
    <Route path="/game" element={<Game />} />
    <Route path="/mobile" element={<Mobile />} />
    <Route path="/giftshop" element={<GiftShop />} />
    <Route path="/payment-game" element={<PaymentGame />} />
    <Route path="/payment-mobile" element={<PaymentMobile />} />
    <Route path="/policy-privacy" element={<PolicyPrivacy />} />
    <Route path="/login" element={<Login />} />
    <Route path="/register" element={<Register />} />

    <Route path="/*" element={<Notfound />} />
  </Routes>
);

export default AppRoutes;
